import { useState } from "react"

export const useGlobalStates = () => {
    
    // para la modal
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')
    const [componentModalDeposit, setComponentModalDeposit ] = useState('')


    return Object.freeze({
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        componentModalDeposit, setComponentModalDeposit,
    })
}